
import { DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import EditContentForm from "@/components/forms/EditContentForm";
import { useEffect } from "react";

interface EditDialogContentProps {
  isLoading: boolean;
  contentData: any;
  contentId: string;
  onComplete: () => void;
}

const EditDialogContent = ({ 
  isLoading, 
  contentData, 
  contentId, 
  onComplete 
}: EditDialogContentProps) => {
  useEffect(() => {
    console.log('[EditDialogContent] rendered with content data:', 
      contentData ? { id: contentData.id, title: contentData.title } : 'no data');
  }, [contentData]);

  if (isLoading) {
    return (
      <div className="py-6 flex justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-clustr-blue border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!contentData) {
    return (
      <div className="py-4 text-center text-red-500">
        Content not found or could not be loaded.
      </div>
    );
  }

  // Ensure all required fields are present in the data
  const completeData = {
    ...contentData,
    // Set default values for any potentially missing fields
    title: contentData.title || '',
    url: contentData.url || '',
    description: contentData.description || '',
    content_type: contentData.content_type || 'webpage',
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>Edit Content Data</DialogTitle>
        <DialogDescription>
          Update the details of your saved content.
        </DialogDescription>
      </DialogHeader>
      <EditContentForm 
        contentId={contentId} 
        initialData={completeData} 
        onComplete={() => {
          console.log('[EditDialogContent] onComplete callback fired');
          onComplete();
        }} 
      />
    </>
  );
};

export default EditDialogContent;
